import * as React from 'react';

export const SvgCloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      d="M0 0l16 16M0 16L16 0"
      fill="none"
      fillRule="evenodd"
      stroke="#1C273F"
      strokeWidth={1.5}
      opacity={0.6}
    />
  </svg>
);
